import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import CreateVariantForm from '../../../modules/variants/components/CreateVariantForm';

const CreateVariant = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  dispatch(
    setBreadCrumbsData({
      page_title: t('create_variant')
    })
  );

  return (
    <div>
      <CreateVariantForm />
    </div>
  );
};

export default CreateVariant;
